import React from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';
import { Loader } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import UnapprovedPlaceHolder from '@/home/components/UnapprovedPlaceHolder';
import { firstError } from '@/utils/errors';
import LoginErrorPlaceHolder from '@/home/components/LoginErrorPlaceHolder';
import LogoutButton from '@/home/components/LogoutButton';
import Selectors from '../hooks/selectors';
import CookieConsentLayout from './CookieConsentLayout';

const LayoutLoader = ({ children }) => {
  const {
    approved, commonsMode, currentUser, isLoading, theme,
  } = Selectors.useLayoutLoader();
  if ((currentUser && isLoading) || (commonsMode && !currentUser)) {
    return (
      <Loader active className={clsx('aridhia-layout-loader', `aridhia-theme-${theme}`)}>
        <FormattedMessage id="loading" />
      </Loader>
    );
  }

  if (currentUser && currentUser.readStatus === states.ERROR) {
    return (
      <LoginErrorPlaceHolder error={firstError(currentUser.readErrors)}>
        <LogoutButton />
      </LoginErrorPlaceHolder>
    );
  }

  if (!approved) {
    return (<UnapprovedPlaceHolder />);
  }

  return (
    <CookieConsentLayout theme={theme}>
      {children}
    </CookieConsentLayout>
  );
};

export default LayoutLoader;
